import axios from "axios";

const API_URL = `${process.env.REACT_APP_API_URL}/faqs`; // Replace with your actual API URL

const customHeaders = {
    'Content-Type': 'application/json'
  };

// Get all room types
        //  @ts-ignore 

export const fetchFaq = async (page,limit) => {
  const response = await axios.get(`${API_URL}?page=${page}&limit=${limit}`,{headers: customHeaders});
  return response.data;
};

export const fetchFaqById = async (id: string) => {
    const response = await axios.get(`${API_URL}/${id}`, { headers: customHeaders });
    return response.data;
  };
// Create a new room type
export const addFaq = async (newFaq: any) => {
  const response = await axios.post(API_URL, newFaq,{headers: customHeaders});
  return response.data;
};

// Edit an existing room type
export const updateFaq = async (id: string, updatedFaq: any) => {
  const response = await axios.put(`${API_URL}/${id}`, updatedFaq,{headers: customHeaders});
  return response.data;
};

// Delete a room type
export const removeFaq = async (id: string) => {
  const response = await axios.delete(`${API_URL}/${id}`,{headers: customHeaders});
  return response.data;
};
